import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * Fires when a link is clicked
 */
export interface LinkClick {
  /**
   * The text that is displayed to the user in English, if the text is in other language, do not pass a value
   */
  linkText?: string | null;
  /**
   * the URL the user is trasnferred to
   */
  destinationUrl: string;
}

export const linkClick = (data: LinkClick, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/link_click/jsonschema/2-0-0', data },
    context
  });
